import { API } from '../../lib/api';

export const STATUSES = { a_valider: 'À valider', valide: 'Validé', contacte: 'Contacté', repondu: 'Réponse reçue', interesse: 'Intéressé', non_interesse: 'Non intéressé', stop: 'STOP définitif' };
export const errorMessage = error => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : error.message || 'Une erreur est survenue.';

export async function streamProspection(path, body, onDelta) {
  const response = await fetch(`${API}/admin/prospection${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('se_admin_token')}` }, body: JSON.stringify(body),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(typeof data.detail === 'string' ? data.detail : 'La requête n’a pas abouti.');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '', result;
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n\n'); buffer = parts.pop();
    for (const part of parts) {
      if (!part.startsWith('data: ')) continue;
      const item = JSON.parse(part.slice(6));
      if (item.type === 'delta') onDelta?.(item.text);
      if (item.type === 'error') throw new Error(item.message);
      if (item.type === 'done') result = item;
    }
  }
  if (!result) throw new Error('Connexion interrompue. Actualisez la liste avant de relancer.');
  return result;
}